import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getAppointment = (clinicId,date="today",docId)=>{
    if(docId === 0 ){
        return axios.get(API_URL+"clinics/"+clinicId+"/appointments?apptDate="+date)
    }else{
        return axios.get(API_URL+"clinics/"+clinicId+"/appointments?apptDate="+date+"&doctorId="+docId)
    }
   
}

const updateAppointmentStatus = (clinicId,appointmentid,apptStatus) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/appointments/"+appointmentid+"?status="+apptStatus)

}

const getAppointmentNotes = (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/appointments/notes")
}
const saveAppointmentNotes = (clinicId, notes)=>{
    return axios.post(API_URL+"clinics/"+clinicId+"/appointments/notes", notes)
}
const deleteAppointmentNotes = (clinicId, notesId)=>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/appointments/notes/"+notesId)
}
export default {
    getAppointment,
    updateAppointmentStatus,
    getAppointmentNotes,
    saveAppointmentNotes,
    deleteAppointmentNotes

}